import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Loader } from '@calendly/ui/components/loader';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
const emptyResultsCss = "eis5dkc";
const EmptyResults = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(emptyResultsCss, props.className)} />;
});
export const LoadingOrEmptyState = ({
  hasLoadedSearchItems = false,
  hasSearchTermOrAppliedFilters = false,
  isLoading = true,
  onCreateEventTypeClick
}) => {
  if (isLoading) {
    return <Loader />;
  }
  if (hasSearchTermOrAppliedFilters) {
    return hasLoadedSearchItems ? <EmptyResults>
        <BodyText inline color="muted">
          {I18n.t('publisher.landing_pages.edit.event_types_picker.no_search_results.end')}
        </BodyText>
      </EmptyResults> : <EmptyResults>
        <BodyText inline weight="bold">
          {I18n.t('publisher.landing_pages.edit.event_types_picker.no_search_results.title')}
        </BodyText>
        <BodyText inline>
          {I18n.t('publisher.landing_pages.edit.event_types_picker.no_search_results.help_text')}
        </BodyText>
      </EmptyResults>;
  }
  return <EmptyResults onClick={onCreateEventTypeClick}>
      <BodyText inline color="muted">
        {HtmlParser(I18n.t('publisher.event_types.list.empty.message', {
        create_event_type_path: '/event_types/new'
      }))}
      </BodyText>
    </EmptyResults>;
};

require("./loading_empty_state.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./loading_empty_state.js");